
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { fetchBanners } from "@/services/userService";

@Component
export default class HomePopupBanner extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly visible!: boolean;

  @Prop({ type: Boolean, default: true })
  readonly saveOnClose!: boolean;

  private popupBanner: BannerData | null = null;

  @Emit("update:visible")
  private close(): boolean {
    if (this.saveOnClose) {
      sessionStorage["first-banner"] = "1";
    }
    return false;
  }

  @Watch("visible", { immediate: true })
  private onVisibleChange(visible: boolean): void {
    if (visible && !this.popupBanner) {
      this.getPopupBanner();
    }
  }

  private async getPopupBanner(): Promise<void> {
    const res = await fetchBanners({ cat: "popup-banner" });
    if (res.length > 0) {
      const ran = Math.floor(Math.random() * res.length);
      this.popupBanner = res[ran];
    }
  }
}
